import type {WidgetFragment as Widget} from 'nutshell-graphql-types';

import {CustomFieldsWidgetShell} from '../../../../core-entity/widgets/custom-fields-widget/components/custom-fields-widget-shell';
import {LegacyIdRow} from '../../../../core-entity/widgets/custom-fields-widget/components/legacy-id-row';
import {useGetWidgetCustomFields} from '../../../../core-entity/widgets/custom-fields-widget/graphql/hooks/use-get-widget-custom-fields';

import {useAccountCustomFieldHandlers} from '../../hooks/use-account-custom-field-handlers';

import {useGetAccountLegacyId} from './graphql/hooks/use-get-account-legacy-id';
import {useUpdateAccountLegacyId} from './graphql/hooks/use-update-account-legacy-id';

interface Props {
    accountId: string;
    widget: Widget;
}

export function AccountAllCustomFieldsWidget(props: Props) {
    const handlers = useAccountCustomFieldHandlers(props.accountId);
    const {customFields, isFirstLoad: isCustomFieldsFirstLoad} = useGetWidgetCustomFields(
        props.accountId,
        props.widget.id
    );
    const {
        legacyId,
        shouldShowLegacyId,
        isFirstLoad: isLegacyIdFirstLoad,
    } = useGetAccountLegacyId(props.accountId);
    const {updateAccountLegacyId} = useUpdateAccountLegacyId();

    const isFirstLoad = isCustomFieldsFirstLoad || isLegacyIdFirstLoad;

    const extraRows = shouldShowLegacyId
        ? [
              <LegacyIdRow
                  key='legacy-id'
                  value={legacyId}
                  onUpdate={(newValue) => updateAccountLegacyId(props.accountId, newValue)}
              />,
          ]
        : [];

    return (
        <CustomFieldsWidgetShell
            entityId={props.accountId}
            widget={props.widget}
            handlers={handlers}
            emptyStateKey='leadCustomFields'
            customFields={customFields}
            isFirstLoad={isFirstLoad}
            extraRows={extraRows}
        />
    );
}
